<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBulletPoint_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path fill="currentColor" d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
</svg>
